import React, { PropsWithChildren } from 'react';

type SwipeableCardButtonProps = PropsWithChildren<{
  onPress: () => void;
  buttonWidth: number;
}>;

export const SwipeableCardButton: React.FC<SwipeableCardButtonProps> = ({
  children,
  onPress,
  buttonWidth,
}) => {
  return (
    <button
      className="swipe-btn"
      style={{ width: buttonWidth }}
      onClick={onPress}
    >
      {children}
    </button>
  );
};
